<template>
  <div class="our-costumers-page">
    <div class="upper-menu" v-if="this.isShowUpMenu">
      <img @click="goToStart"
           v-if="window.location.href.includes('projects') || window.location.href.includes('contactus')"
           class="menu-icon-left" src="/static/img/global/hippo_logo_purple.svg" alt="Menu">
      <img @click="goToStart" v-else class="menu-icon-left" src="/static/img/global/hippo_logo_white.svg"
           alt="Menu">

      <img @click="goToMenu" class="menu-icon" src="/static/img/menu.svg" alt="Menu"
           v-if="!window.location.href.includes('site-menu') && !window.location.href.includes('projects')">
      <img @click="goToMenu" class="menu-icon" src="/static/img/menu-copy-2.svg" alt="Menu"
           v-if="window.location.href.includes('projects') || window.location.href.includes('contactus')">
      <img v-if="window.location.href.includes('cover') && !this.isMobile" class="menu-project-right"
           @click="seeOurProjects" src="/static/img/menu-project-2.png" alt="Projects">
    </div>
    <MenuSide/>
    <div v-if="!this.isMobile" class="banner">

      <img class="bg" src="../../static/img/banners/adult-agency-business3.jpg"
           srcset="../../static/img/banners/adult-agency-business3.jpg" alt="Hippotec">

      <div class="container logo">
        <div class="row">
          <div class="col-xl-12 col-md-12 col-sm-12 ">
            <div class="title-image" v-bind:style="{'font-size':this.mobileSite.titleFontSize}">THE SECRET</div>
            <div class="title-image">IS COLLABORATION</div>
            <img class="curved-line" src="../../static/img/global/pink-line.svg" alt="">
          </div>
          <div class="col-xl-12 col-md-12 col-sm-12 row-col">
            <div class="title-image-small">Our customers always fill at home. <br/>
              They can come visit us when ever they like, ask questions and drink<br/> coffee. be a part of the proccess
              with full transparency.
            </div>
          </div>
        </div>
        <button @click="seeOurProjects" class="submit-button" type="submit">VIEW OUR WORK</button>
      </div>
      <div class="overlay"></div>
    </div>
    <div v-else class="mobile-banner">

      <img class="bg" src="../../static/img/banners/adult-agency-business3.jpg"
           srcset="../../static/img/banners/adult-agency-business3.jpg" alt="Hippotec">

      <div class="container uppertext">
        <div class="row">
          <div class="col-xl-12 col-md-12 col-sm-12 ">
            <div class="title-image" v-bind:style="{'font-size':this.mobileSite.titleFontSize}">THE</div>
            <div class="title-image" v-bind:style="{'font-size':this.mobileSite.titleFontSize}">SECRET IS</div>
            <div class="title-image" v-bind:style="{'font-size':this.mobileSite.titleFontSize}">COLLABORATION</div>
            <img class="mobile-curved-line" src="../../static/img/global/pink-line.svg" alt="">
          </div>
          <div class="col-xl-12 col-md-12 col-sm-12 row-col">
            <div class="title-image-small">Our customers always feel at home. <br/>
              They can come visit us when ever they like, ask questions and drink<br/> coffee. be a part of the process
              with full transparency.
            </div>
          </div>
        </div>
        <button @click="seeOurProjects" class="submit-button" type="submit">VIEW OUR WORK</button>
      </div>
      <div class="overlay"></div>
    </div>
    <section class="container our-costumers">

      <div class="title">OUR CUSTOMERS</div>
      <div class="content">

        <div class="projects-table">

          <div v-for="(project, index) in companies">
            <div class="company">
              <img v-if="project.isActive" :src="project.hover" class="project-image-hover"
                   @mouseleave="project.isActive = false" alt="">
              <img v-else :src="project.hover" class="project-image" @mouseover="project.isActive = true" @click="showAppDetails(index)" alt="">
            </div>
          </div>
        </div>

      </div>
    </section>

    <section class="container our-costumers-say">

      <div class="title" >OUR CUSTOMERS SAY</div>
      <div class="content">
        <carousel @pageChange="onPageChanged" :autoplay=true paginationPosition='top' :paginationEnabled=false :navigate-to="carouselPageNumber"
                  :scrollPerPage="true" :perPage="1" :paginationPadding="10" :loop="true" :autoplayTimeout="15000">

          <slide class="slide" v-for="(slide, index) in slides">
            <div class="slide-text">
              {{slide.text}}
            </div>
            <div class="slide-name">
              {{slide.name}}
            </div>
            <div class="slide-work">
              {{slide.work}}
            </div>
          </slide>
        </carousel>

      </div>

      <div class="paging-content">
        <div v-for="(item, index) in slides">
          <div class="carousel-page-count" @click="navigateToSlide(index)">
            <img v-if="item.isActive" class="image" src="../../static/img/path.png" alt="">
            <img v-else class="image" style="opacity: 0" src="../../static/img/path.png" alt="">
            <div class="page">{{ index + 1 }}</div>
          </div>

        </div>
      </div>
    </section>

    <contact-us/>


  </div>

</template>

<script>
  import {Carousel, Slide} from 'vue-carousel';
  //import ContactUs from "../components/ContactUs";
  //import MenuSide from "./../components/MenuSide"
  import backgroundimage from '../../static/img/banners/adult-agency-business2.8edc0c5.jpg'
  import backgroundmobileimage from '../../static/img/banners/adult-agency-business2.8edc0c5.jpg'
  import ourcustomersimage from '../../static/img/combinedShape.png'
  import bgmobile from "../../static/img/WhoAreWe/shellymobile.png";
  import logomobile from "../../static/img/WhoAreWe/logomobile.png";
  import seeourprojectsmobile from "../../static/img/WhoAreWe/hippoIconmobile.png";
  import bg from "../../static/img/WhoAreWe/shelly.jpg";
  import logonew from "../../static/img/WhoAreWe/logo.png";
  import seeourprojects from "../../static/img/WhoAreWe/see-our-projects.svg";

  import MenuSide from '@bit/hippotec.website2019.menu-side';
  import ContactUs from '@bit/hippotec.website2019.contact-us';

  export default {
    name: 'OurCostumers',
    data() {
      return {
        slides: [
          {
            text: 'Hippotec has developed for us an advanced sophisticated application. During the project, ' +
              'they showed professionalism and extensive knowledge in development and in learning our business.' +
              'Our clients from all over the world are working with this application and enjoying high class' +
              'technology.',
            name: 'Ziv Vidas',
            work: 'Product manager, Maytronics',
            isActive: true,
          },{
            text: 'Working with HippoTec team was an exciting experience for us, building our business, cross organizational application and the system supports it.',
            name: 'Sagiv Rosenshtein',
            work: 'Product Manager, Stratasys',
            isActive: false,
          },{
            text: 'To me working with Hippotec always meant working with a highly responsive team that was attentive to me as a customer and to our company\'s needs, receiving efficient solutions that met our requirements and constraints, and all this in a very professional yet down to earth atmosphere.',
            name: 'Rotem Marco',
            work: 'Product Manager, Earlysense',
            isActive: false,
          },{
            text: 'Hippotec did our mobile web UX and design work, the process was very efficient and professional, and the guys are 100% mobile experts.',
            name: 'Tal Agasi',
            work: 'Founder & CEO, GOTit',
            isActive: false,
          },
        ],
        carouselPageNumber: 0,
        image: backgroundimage,
        ourCustomersImage: ourcustomersimage,
        companies: [{
          isActive: false,
          alt: "Bezeq",
          hover: "/static/img/costumers/Bezeq/logo.png",
          srcset: "/static/img/costumers/black/bezeqNewLogoSvg.png",
          src: "/static/img/costumers/black/bezeqNewLogoSvg.png"
        }, {
          isActive: false,
          alt: "Amdocs",
          hover: "/static/img/costumers/Amdocs/logo.png",
          srcset: "/static/img/costumers/black/amdocs.png",
          src: "/static/img/costumers/black/amdocs.png"
        }, {
          isActive: false,
          alt: "Comvers",
          hover: "/static/img/costumers/Comvers/logo.png",
          srcset: "/static/img/costumers/black/comvers.png",
          src: "/static/img/costumers/black/comvers.png"
        }, {
          isActive: false,
          alt: "Curver",
          hover: "/static/img/costumers/Curver/logo.png",
          srcset: "/static/img/costumers/black/curverBlack.png",
          src: "/static/img/costumers/black/curverBlack.png"
        }, {
          isActive: false,
          alt: "Maytronics",
          hover: "/static/img/costumers/mytronics/logo.png",
          srcset: "/static/img/costumers/black/mytronics.png",
          src: "/static/img/costumers/black/mytronics.png"
        }, {
          isActive: false,
          alt: "Homeless",
          hover: "/static/img/costumers/Homeless/logo.png",
          srcset: "/static/img/costumers/black/untitled101.png",
          src: "/static/img/costumers/black/untitled101.png"
        }, {
          isActive: false,
          alt: "Stratasys",
          hover: "/static/img/costumers/Stratasys/logo.png",
          srcset: "/static/img/costumers/black/stratasys01.png",
          src: "/static/img/costumers/black/stratasys01.png"
        }, {
          isActive: false,
          alt: "Israel today",
          hover: "/static/img/costumers/IsraelToday/logo.png",
          srcset: "/static/img/costumers/black/israelTodayBlaco.png",
          src: "/static/img/costumers/black/israelTodayBlaco.png"
        }, {
          isActive: false,
          alt: "Probuild",
          hover: "/static/img/costumers/Probuild/logo.png",
          srcset: "/static/img/costumers/black/probuildGray.png",
          src: "/static/img/costumers/black/probuildGray.png"
        }, {
          isActive: false,
          alt: "Oggii",
          hover: "/static/img/costumers/Oggie/logo.png",
          srcset: "/static/img/costumers/black/oggie01.png",
          src: "/static/img/costumers/black/oggie01.png"
        }, {
          isActive: false,
          alt: "Telll",
          hover: "/static/img/costumers/Telll/logo.png",
          srcset: "/static/img/costumers/black/logoTelll.png",
          src: "/static/img/costumers/black/logoTelll.png"
        }, {
          isActive: false,
          alt: "GreenIQ",
          hover: "/static/img/costumers/GreenIq/logo.png",
          srcset: "/static/img/costumers/black/greenIqLogoVectorized.png",
          src: "/static/img/costumers/black/greenIqLogoVectorized.png"
        }, {
          isActive: false,
          alt: "Tiivii",
          hover: "/static/img/costumers/TiiVii/logo.png",
          srcset: "/static/img/costumers/black/tiivii.png",
          src: "/static/img/costumers/black/tiivii.png"
        }, {
          isActive: false,
          alt: "GOTit",
          hover: "/static/img/costumers/GotIt/logo.png",
          srcset: "/static/img/costumers/black/gotitIcon.png",
          src: "/static/img/costumers/black/gotitIcon.png"
        }, {
          isActive: false,
          alt: "WITH",
          hover: "/static/img/costumers/With/logo.png",
          srcset: "/static/img/costumers/black/with.png",
          src: "/static/img/costumers/black/with.png"
        }, {
          isActive: false,
          alt: "Pixellot",
          hover: "/static/img/costumers/Pixellot/logo.png",
          srcset: "/static/img/costumers/black/pixellot.png",
          src: "/static/img/costumers/black/pixellot.png"
        }, {
          isActive: false,
          alt: "Cronus",
          hover: "/static/img/costumers/Cronus/logo.png",
          srcset: "/static/img/costumers/black/logoCronus.png",
          src: "/static/img/costumers/black/logoCronus.png"
        }, {
          isActive: false,
          alt: "Intuition Robotics",
          hover: "/static/img/costumers/Robotics/logo.png",
          srcset: "/static/img/costumers/black/logoIntuition.png",
          src: "/static/img/costumers/black/logoIntuition.png"
        }
        ],
        mobileSite: {
          titleFontSize: '60px'
        },
        window,
        isShowUpMenu: false,
        upperMenuTopLast: 0,
      }
    },
    methods: {
      checkScroll() {
        const $win = $(window);
        if ($win.scrollTop() > 200) {
          this.isShowUpMenu = this.upperMenuTopLast > $win.scrollTop();
          this.upperMenuTopLast = $win.scrollTop()
        }else{
          this.isShowUpMenu = false;
        }
      },
      goToStart: function () {
        this.$router.push('/what-we-do');
      },
      goToMenu: function () {
        this.$router.push('/site-menu');
      },
      seeOurProjects: function () {
        this.$router.push('projects')
      },
      showAppDetails: function (index) {
          this.$router.push('/cover/' + index);
      },
      navigateToSlide: function (page) {
        this.carouselPageNumber = page;
        for (let i = 0; i < this.slides.length; i++){
          if (i == page){
            this.slides[i].isActive = true
          }else{
            this.slides[i].isActive = false
          }
        }
      },
      onPageChanged: function (evt) {
        this.navigateToSlide(evt)
      },
      prepareMobile(isMobile) {
        this.isMobile = isMobile;
        if (isMobile) {
          this.mobileSite.titleFontSize = '40px';
          this.image = backgroundmobileimage;
        }else{
          this.image = backgroundimage;
        }
      }
    },
    components: {
      ContactUs,
      Carousel,
      Slide,
      MenuSide: MenuSide
    },
    created() {
      this.prepareMobile(localStorage.isMobile == 'true');
    },
    mounted() {
      let $win = $(window);
      $win.scroll(this.checkScroll);
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/our-costumers";
  .upper-menu {
    position: fixed;
    opacity: 0.7;
    width: 100%;
    height: 110px;
    background-color: #000000;
    top: 0;
    left: 0;
    z-index: 2000;
  }
  .menu-icon-left {
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    float: left;
    cursor: pointer;
    left: 56px
  }
  .menu-icon {
    position: absolute;
    float: right;
    width: 52px;
    height: 52px;
    cursor: pointer;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    right: 56px;
    animation: menuclose-icon-right 1s forwards 1s;
  }
  .mobile-banner {
    width: 100%;
    height: 520px;
    overflow: hidden;
    position: relative;

    .bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
      opacity: 0.8;
      object-position: center;
    }

    .logo {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 60%;
      max-width: 100%;
      text-align: center;
      transform: translate(-50%, -50%);
      z-index: 1;

      img {
        zoom: 1.2;
        width: 174px;
        height: 98px;
        object-fit: cover;
        object-position: center;
        margin-bottom: 20px;
      }

      p {
        width: 969px;
        max-width: 100%;
        margin: auto;
        color: #fff;
        font-size: 33px;
        font-weight: 300;
        text-align: center;
      }
    }

    .overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5);
    }
    .uppertext {
      position: absolute;
      top: 100px;
      left: 35px;
      width: 90%;
      max-width: 100%;
      //text-align: center;
      // transform: translate(-50%, -50%);
      z-index: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/OurCostumers.vue